<template>
  <div :class="$style.container">
    <!-- Основная информация о проекте -->
    <project-information
      :project="project"
      :graph="graph"
    ></project-information>
    <!-- График транзакций проекта -->
    <template v-if="graph.length > 0">
      <div
        :class="[
          $style.graph,
          { [$style.visible]: isVisibleGraph },
        ]"
      >
        <transaction-chart
          :data="graph"
        ></transaction-chart>
      </div>
    </template>
    <!-- Доступно для персональных проектов -->
    <template v-if="isPersonalProject">
      <!-- Механизмы управления проектом -->
      <div :class="$style.controls">
        <project-control
          :project="project"
        ></project-control>
      </div>
      <!-- Информационные слайды -->
      <div :class="$style.slides">
        <information-sliding></information-sliding>
      </div>
    </template>
  </div>
</template>

<script>
import ProjectService from 'services/project';

import ProjectControl from 'organisms/project/ProjectControl';
import InformationSliding from 'organisms/project/InformationSliding';
import ProjectInformation from 'templates/project/mobile/ProjectInformationMobileTemplate';

import TransactionChart from '@/plugins/capusta_chart/chart';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'ProjectDashboardMobileTemplate',
  components: {
    ProjectControl,
    InformationSliding,
    ProjectInformation,
    TransactionChart,
  },
  props: {
    graph: {
      type: Array,
      default: () => [],
    },
    project: {
      type: Object,
      required: true,
    },
  },
  created() {
    EVENT_BUS.$on('EVENT_TOOGLE_GRAPH_SHOW', () => {
      this.isVisibleGraph = !this.isVisibleGraph;
    });
  },
  beforeDestroy() {
    EVENT_BUS.$off('EVENT_TOOGLE_GRAPH_SHOW');
  },
  data() {
    return {
      isVisibleGraph: false,
    };
  },
  computed: {
    isPersonalProject() {
      return ProjectService.checkPersonalProject(this.project);
    },
  },
};
</script>

<style lang="sass" module>
  .container
    position: relative

  .graph
    height: 0
    opacity: 0
    visibility: hidden
    transition: .1s ease

    &.visible
      height: auto
      opacity: 1
      visibility: visible

  .controls
    margin-bottom: 20px
    padding: 20px
    background-color: #181823

    // +respond-to('small')
    //   margin: 0

  .slides
    margin: 0 20px

    +respond-to('small')
      margin: 0
</style>
